var React = require('react');

function HeaderMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 0C18.6275 0 24 5.37253 24 12C24 18.6275 18.6275 24 12 24C5.37253 24 0 18.6276 0 12C0 5.37239 5.37267 0 12 0ZM4.61719 16.227C4.61719 16.2323 4.6178 16.2373 4.61789 16.2424L9.66113 12.3134L4.61719 7.84444V16.227ZM14.3391 12.3134L19.3822 16.2424C19.3822 16.2373 19.383 16.2323 19.383 16.227V7.84444L14.3391 12.3134ZM10.4642 13.0248L5.60864 16.8076H18.3916L13.536 13.0248L12.3497 14.0758C12.2533 14.1612 12.1289 14.2084 12 14.2084C11.8712 14.2084 11.7468 14.1612 11.6504 14.0758L10.4641 13.0248H10.4642ZM12 12.9765L18.5285 7.19241H5.47158L12 12.9765Z","fill":"#20BDA3"}));
}

HeaderMail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = HeaderMail;

HeaderMail.default = HeaderMail;
